export enum BasicSecurityTypes {
  Public,
  Password,
}
